import React, { Component} from 'react';
import Aux from '../Auxiliary/Auxiliary'
import Toolbar from '../../components/Navigation/Toolbar/Toolbar'
import SideDrawer from '../../components/Navigation/SideDrawer/SideDrawer'
import classes from './Layout.css'

class Layout extends Component {
    state = {
        showSideDrawer: false,
    };
    sideDrawClosedHandler = () => {
      this.setState({showSideDrawer : false})
    }
    sideDrawerToggleHandler = () => {

        this.setState((prevState) => {
            return {showSideDrawer : !prevState.showSideDrawer}
        })
    }
    render () {
        return (
        <Aux>
            <div>
                <Toolbar drawerToggleClicked={this.sideDrawerToggleHandler}/>
                <SideDrawer open={this.state.showSideDrawer} closed={this.sideDrawClosedHandler}/>

            </div>
            <main className={classes.Content}>
                {this.props.children}
            </main>
        </Aux>
    )}
}
export default Layout


// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js